import React, {Component} from 'react';
import Select from 'react-select';
import axios from 'axios';
import { Route, Routes, useLocation, useNavigate, useParams, Navigate, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Input, Alert, FormText , Form, FormGroup, Col, Label} from 'reactstrap';
import { getAuthToken, getUserLevel } from '../../store/utility';

class KitaStammdaten extends Component {
    state = {
        kita: {},
        kinder: [],
        durchfuehrende: [],
        selectedKind:{
            vorname: '',
            nachname: '',
            geburtsjahr: undefined,
            geburtsmonat: undefined,
            geburtstag: undefined,
            geschlechtObjekt: {id: 0, bezeichnung: ""}
        },
        newKind:{
            vorname: '',
            nachname: '',
            geburtsjahr: undefined,
            geburtsmonat: undefined,
            geburtstag: undefined,
            geschlechtObjekt: {id: 0, bezeichnung: ""}
        },
        Geschlechter: [],
        updateKind: false,
        createNewKind: false,
        kindSelected: false,
        file: '',
        createdKinder: [],
        showUploadKindSuccessAlert: false,
        showDeleteKindSuccessAlert: false
    };

    constructor(props) {
        super(props);
        const token = getAuthToken();
        const kitaID = getUserLevel();
        axios.get(this.props.apiUri + 'Kita/GetKita?pKitaID=' + kitaID, { headers: { 'Authorization': `Bearer ${token}` } })
            .then(response => {
                this.setState({ kita: response.data });
            }).then(
                axios.get(this.props.apiUri + 'Geschlecht').then(response => {
                    this.setState({ Geschlechter: response.data });
                }).then(
                    axios.get(this.props.apiUri + 'Kind/GetKinderOfKita?pKitaID=' + kitaID, { headers: { 'Authorization': `Bearer ${token}` } }).then(response => {
                        this.setState({ kinder: response.data.filter(function (obj) { return obj.aktiv === true; }) });
                    }
                    )));
    }


    newKindCreated = () => {
        let selectedKind = {
            vorname: '',
            nachname: '',
            geburtsjahr: undefined,
            geburtsmonat: undefined,
            geburtstag: undefined,
            geschlechtObjekt: {id: 0, bezeichnung: ""}
        };
        axios.get(this.props.apiUri + 'Kind/GetKinderOfKita?pKitaID=' +  this.state.kita.id, {headers: {'Authorization': `Bearer ${this.props.token}`}})
                        .then(response => {
                            this.setState({
                                kinder: response.data.filter(function (obj) { return obj.aktiv === true; }),
                                selectedKind:selectedKind,
                                newKind: selectedKind,
                                showKinder: true,
                                createNewKind: false,
                                showUploadKindSuccessAlert: true
                            });
                        });
    }

    KindDeleted = () => {
        let selectedKind = {
            vorname: '',
            nachname: '',
            geburtsjahr: undefined,
            geburtsmonat: undefined,
            geburtstag: undefined,
            geschlechtObjekt: { id: 0, bezeichnung: "" }
        };
        axios.get(this.props.apiUri + 'Kind/GetKinderOfKita?pKitaID=' + this.state.kita.id, { headers: { 'Authorization': `Bearer ${this.props.token}` } })
            .then(response => {
                this.setState({
                    kinder: response.data.filter(function (obj) { return obj.aktiv === true; }),
                    selectedKind: selectedKind,
                    newKind: selectedKind,
                    showKinder: true,
                    createNewKind: false,
                    showDeleteKindSuccessAlert: true
                });
            });
    }


    kindChangeHandler = pSelectedKind => {
        let kindSelected = false;
        let selectedKind = {
            vorname: '',
            nachname: '',
            geburtsjahr: undefined,
            geburtsmonat: undefined,
            geburtstag: undefined,
            geschlechtObjekt: {id: 0, bezeichnung: ""}
        };
        if(pSelectedKind !== null){
            kindSelected = true;
            selectedKind = {...pSelectedKind};
            if(selectedKind.geburtsmonat === null || selectedKind.geburtsmonat === undefined){
                selectedKind.geburtsmonat = 0;
            }
            if(selectedKind.geburtstag === null || selectedKind.geburtstag === undefined){
                selectedKind.geburtstag = 0;
            }
        }
        this.setState({
            selectedKind: selectedKind,
            kindSelected: kindSelected,
            newKind: selectedKind,
            updateKind: false,
            showUploadKindSuccessAlert: false,
            showDeleteKindSuccessAlert: false
        });
    };

    KindVornameChangedHandler = value => {
        let updatedKind = {...this.state.newKind};
        updatedKind.vorname = value;
        this.setState({
            newKind: updatedKind
        });
    }

    KindNachnameChangedHandler = value => {
        let updatedKind = {...this.state.newKind};
        updatedKind.nachname = value;
        this.setState({
            newKind: updatedKind
        });
    }

    KindGeschlechtChangedHandler = value => {
        let updatedKind = {...this.state.newKind};
        updatedKind.geschlechtObjekt = value;
        this.setState({
            newKind: updatedKind
        });
    }

    KindGeburtsjahrChangedHandler = value => {
        let updatedKind = {...this.state.newKind};
        updatedKind.geburtsjahr = parseInt(value);
        this.setState({
            newKind: updatedKind
        });
    }

    KindGeburtsmonatChangedHandler = value => {
        let updatedKind = {...this.state.newKind};
        updatedKind.geburtsmonat = parseInt(value);
        this.setState({
            newKind: updatedKind
        });
    }

    KindGeburtstagChangedHandler = value => {
        let updatedKind = {...this.state.newKind};
        updatedKind.geburtstag = parseInt(value);
        this.setState({
            newKind: updatedKind
        });
    }

    toggleUpdateKind = value => {
        this.setState({
            updateKind: value
        });
    }

    deleteKind = (id) => {
        axios.delete(this.props.apiUri + 'Kind/' + id, { headers: { 'Authorization': `Bearer ${this.props.token}` } })
            .then(response => {
                this.KindDeleted();
            });
    }

    toggleCreateKind = value => {
        this.setState({
            createNewKind: value
        });
    }

    createNewKind = (kind) => {
        let selectedKita = {...this.state.kita};
        if(kind.geburtstag === undefined && kind.geburtsmonat === undefined && kind.geburtsjahr === undefined)
        {
            axios.post(this.props.apiUri + 'Kind?pKitaID=' + selectedKita.id + '&pVorname=' + kind.vorname + '&pNachname=' + kind.nachname + '&pGeschlechtID=' + kind.geschlechtObjekt.id,null , {headers: {'Authorization': `Bearer ${this.props.token}`}})
            .then(response => {
                this.newKindCreated();
                this.setState({
                    createdKinder: response.data
                });
            }); 
        }
        if(kind.geburtstag === undefined && kind.geburtsmonat === undefined && kind.geburtsjahr !== undefined){
            axios.post(this.props.apiUri + 'Kind?pKitaID=' + selectedKita.id + '&pVorname=' + kind.vorname + '&pNachname=' + kind.nachname + '&pGeschlechtID=' + kind.geschlechtObjekt.id + '&pGeburtsjahr=' + kind.geburtsjahr,null , {headers: {'Authorization': `Bearer ${this.props.token}`}})
            .then(response => 
                {
                    this.newKindCreated();
                    this.setState({
                        createdKinder: response.data
                    });
                }); 
        }
        if(kind.geburtstag === undefined && kind.geburtsmonat !== undefined && kind.geburtsjahr !== undefined){
            axios.post(this.props.apiUri + 'Kind?pKitaID=' + selectedKita.id + '&pVorname=' + kind.vorname + '&pNachname=' + kind.nachname + '&pGeschlechtID=' + kind.geschlechtObjekt.id + '&pGeburtsjahr=' + kind.geburtsjahr + '&pGeburtsmonat=' + kind.geburtsmonat,null , {headers: {'Authorization': `Bearer ${this.props.token}`}})
            .then(response => 
                {
                    this.newKindCreated();
                    this.setState({
                        createdKinder: response.data
                    });
                });  
        }
        if(kind.geburtstag !== undefined && kind.geburtsmonat !== undefined && kind.geburtsjahr !== undefined){
            axios.post(this.props.apiUri + 'Kind?pKitaID=' + selectedKita.id + '&pVorname=' + kind.vorname + '&pNachname=' + kind.nachname + '&pGeschlechtID=' + kind.geschlechtObjekt.id + '&pGeburtsjahr=' + kind.geburtsjahr + '&pGeburtsmonat=' + kind.geburtsmonat + '&pGeburtstag=' + kind.geburtstag,null , {headers: {'Authorization': `Bearer ${this.props.token}`}})
                .then(response => 
                    {
                        this.newKindCreated();
                        this.setState({
                            createdKinder: [response.data]
                        });
                    }); 
        }
    }

    onFileChange = (event) => {
		this.setState({
			file: event.target.files[0]
		});
    }
    
    downloadMuster = () => {
        axios({
            url: this.props.apiUri + 'Kind/DownloadMuster',
            method: 'GET',
            responseType: 'blob', // important
            headers: {'Authorization': `Bearer ${this.props.token}`}
          }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'}));
            const link = document.createElement('a');
            link.href = url;
            link.download = "Kinder.xlsx";

            // link.setAttribute('download', this.state.selectedKind.nachname + '.pdf');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          });
    }

    uploadFileData = (event) => {
		event.preventDefault();
		let data = new FormData();
		data.append('file', this.state.file);
        axios.post(this.props.apiUri + 'Kind/UploadKinder?pKitaID=' + this.state.kita.id, data, {headers: {'Authorization': `Bearer ${this.props.token}`}})
            .then(response => {
                this.setState({
                    createdKinder: response.data,
                    showUploadKindSuccessAlert: true,
                    file: ''
                });
            return axios.get(this.props.apiUri + 'Kind/GetKinderOfKita?pKitaID=' +  this.state.kita.id, {headers: {'Authorization': `Bearer ${this.props.token}`}})
            .then(response => {
                this.setState({
                    kinder: response.data
                });
            });
            });


    }

    updateKind = (kind) => {
        const updatedKind = { Vorname: kind.vorname, Nachname: kind.nachname, GeschlechtID: kind.geschlechtObjekt.id, Geburtsjahr: kind.geburtsjahr, Geburtsmonat: kind.geburtsmonat, Geburtstag: kind.geburtstag, Aktiv: kind.aktiv }
        axios.post(this.props.apiUri + 'Kind/UpdateKind?id=' + kind.id,
            updatedKind,
            { headers: { 'Authorization': `Bearer ${this.props.token}` } })
            .then(response => {
                axios.get(this.props.apiUri + 'Kind/GetKinderOfKita?pKitaID=' + this.state.kita.id, { headers: { 'Authorization': `Bearer ${this.props.token}` } })
                    .then(response => {
                        this.setState({
                            kinder: response.data,
                            selectedKind: kind,
                            updateKind: false
                        });
                    })
            }); 
    }

    CreateStringFromIndizes = (Indizes) => {
        return Indizes.join(' , ');
    }

    render(){
        const kinder = [...this.state.kinder];

        let kinderList = null;
            kinderList = (
                <div>
                    <h3>Kinder</h3>
                    <Select 
                        getOptionLabel={option => `${option.vorname} ${option.nachname}`}
                        getOptionValue={option => option.id}
                        options={kinder}
                        onChange={(event) => this.kindChangeHandler(event)}
                        value={this.state.selectedKind}
                        isOptionDisabled={(option) => !option.aktiv}
                        isClearable='true'/>
                </div>
            );
        

        let kindEdit = null;
        
            if(this.state.kindSelected)
            {
                if(!this.state.updateKind){
                    kindEdit = (
                        <div>
                            <button
                                className="btn btn-primary"
                                onClick={() => this.toggleUpdateKind(true)}
                                type="button"> Kind bearbeiten
                            </button>
                            {/*<button*/}
                            {/*    className="btn btn-danger"*/}
                            {/*    onClick={() => this.deleteKind(this.state.selectedKind.id)}*/}
                            {/*    type="button"> Kind löschen*/}
                            {/*</button>*/}
                            <br/>
                            <br />
                            <FormGroup row>
                                <Label for="Vorname" sm={2}>Vorname</Label>
                                <Col sm={4}>
                                    <Input readonly type="text" id="Vorname" value={this.state.newKind.vorname} />
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="Nachname" sm={2}>Nachname</Label>
                                <Col sm={4}>
                                    <Input readonly type="text" id="Nachname" value={this.state.newKind.nachname} />
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="Geschlecht" sm={2}>Geschlecht</Label>
                                <Col sm={4}>
                                    <Input readOnly type="text" id="Geschlecht" value={this.state.selectedKind.geschlechtObjekt.bezeichnung} />
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="Geburtstag" sm={2}>Geburtsdatum</Label>
                                <Col sm={1}>
                                    <Input readonly type="number" id="Geburtstag" value={this.state.newKind.geburtstag} />
                                    <FormText>Tag</FormText>
                                </Col>
                                <Col sm={1}>
                                    <Input readonly type="number" id="Geburtsmonat" value={this.state.newKind.geburtsmonat} />
                                    <FormText>Monat</FormText>
                                </Col>
                                <Col sm={1}>
                                    <Input readonly type="number" id="Geburtsjahr" value={this.state.newKind.geburtsjahr} />
                                    <FormText>Jahr</FormText>
                                </Col>

                            </FormGroup>
                        </div>
                    );
                }
                else {
                    kindEdit = (
                        <div>
                            <button
                            className="btn btn-primary"
                            onClick={() => this.toggleUpdateKind(false)}
                            type="button"> Kind nicht mehr bearbeiten
                            </button>
                            <br/>
                            <br />
                            <Form>
                                <FormGroup row>
                                    <Label for="Vorname" sm={2}>Vorname</Label>
                                    <Col sm={4}>
                                        <Input type="text" id="Vorname" value={this.state.newKind.vorname} onChange={(e) => this.KindVornameChangedHandler(e.target.value)} />
                                        <FormText>Bitte geben Sie hier den Vornamen des Kindes ein z.B. Tom</FormText>
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Label for="Nachname" sm={2}>Nachname</Label>
                                    <Col sm={4}>
                                        <Input type="text" id="Nachname" value={this.state.newKind.nachname} onChange={(e) => this.KindNachnameChangedHandler(e.target.value)} />
                                        <FormText>Bitte geben Sie hier den Nachnamen des Kindes ein z.B. Schmidt</FormText>
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Label for="Geschlecht" sm={2}>Geschlecht</Label>
                                    <Col sm={4}>
                                        <Select
                                            id="Geschlecht"
                                            getOptionLabel={option => `${option.bezeichnung}`}
                                            getOptionValue={option => option.id}
                                            options={this.state.Geschlechter}
                                            onChange={(value) => this.KindGeschlechtChangedHandler(value)}
                                            value={this.state.newKind.geschlechtObjekt}
                                            isClearable='true' />
                                        <FormText>Bitte geben sie hier das Geschlecht des Kindes an</FormText>

                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Label for="Geburtstag" sm={2}>Geburtsdatum</Label>
                                    <Col sm={1}>
                                        <Input type="number" id="Geburtstag" value={this.state.newKind.geburtstag} onChange={(e) => this.KindGeburtstagChangedHandler(e.target.value)} />
                                        <FormText>Tag</FormText>
                                    </Col>
                                    <Col sm={1}>
                                        <Input type="number" id="Geburtsmonat" value={this.state.newKind.geburtsmonat} onChange={(e) => this.KindGeburtsmonatChangedHandler(e.target.value)} />
                                        <FormText>Monat</FormText>
                                    </Col>
                                    <Col sm={1}>
                                        <Input type="number" id="Geburtsjahr" value={this.state.newKind.geburtsjahr} onChange={(e) => this.KindGeburtsjahrChangedHandler(e.target.value)} />
                                        <FormText>Jahr</FormText>
                                    </Col>

                                </FormGroup>
                                <FormGroup>
                                    <Col sm={10}>
                                        <button
                                            className="btn btn-primary"
                                            onClick={() => this.updateKind(this.state.newKind)}
                                            type="button"> Änderungen speichern
                                        </button>
                                    </Col>
                                </FormGroup>
                            </Form>
                        </div>


                    );
                }   
            }
        
            else{
                if(this.state.createNewKind){
                    let disabled = true;
                    if(this.state.newKind.vorname && this.state.newKind.nachname && this.state.newKind.geschlechtObjekt.id !== 0 && this.state.newKind.geburtsjahr){
                        disabled = false;
                    }
                    kindEdit = (
                        <Form>
                            <FormGroup row>
                                <Label for="Vorname" sm={2}>Vorname</Label>
                                <Col sm={4}>
                                    <Input type="text" id="Vorname" value={this.state.newKind.vorname} onChange={(e) => this.KindVornameChangedHandler(e.target.value)} />
                                    <FormText>Bitte geben Sie hier den Vornamen des Kindes ein z.B. Tom</FormText>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="Nachname" sm={2}>Nachname</Label>
                                <Col sm={4}>
                                    <Input type="text" id="Nachname" value={this.state.newKind.nachname} onChange={(e) => this.KindNachnameChangedHandler(e.target.value)} />
                                    <FormText>Bitte geben Sie hier den Nachnamen des Kindes ein z.B. Schmidt</FormText>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="Geschlecht" sm={2}>Geschlecht</Label>
                                <Col sm={4}>
                                    <Select
                                        id="Geschlecht"
                                        getOptionLabel={option => `${option.bezeichnung}`}
                                        getOptionValue={option => option.id}
                                        options={this.state.Geschlechter}
                                        onChange={(value) => this.KindGeschlechtChangedHandler(value)}
                                        value={this.state.newKind.geschlechtObjekt}
                                        isClearable='true' />
                                    <FormText>Bitte geben sie hier das Geschlecht des Kindes an</FormText>

                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="Geburtstag" sm={2}>Geburtsdatum</Label>
                                <Col sm={1}>
                                    <Input type="number" id="Geburtstag" value={this.state.newKind.geburtstag} onChange={(e) => this.KindGeburtstagChangedHandler(e.target.value)} />
                                    <FormText>Tag</FormText>
                                </Col>
                                <Col sm={1}>
                                    <Input type="number" id="Geburtsmonat" value={this.state.newKind.geburtsmonat} onChange={(e) => this.KindGeburtsmonatChangedHandler(e.target.value)}/>
                                    <FormText>Monat</FormText>
                                </Col>
                                <Col sm={1}>
                                    <Input type="number" id="Geburtsjahr" value={this.state.newKind.geburtsjahr} onChange={(e) => this.KindGeburtsjahrChangedHandler(e.target.value)}/>
                                    <FormText>Jahr</FormText>
                                </Col>
                                
                            </FormGroup>
                            <FormGroup>
                                <Col sm={10}>
                                    <button
                                    disabled={disabled}
                                    className="btn btn-primary"
                                    onClick={() => this.createNewKind(this.state.newKind)}
                                    type="button"> Neues Kind speichern
                                </button>
                                </Col>
                            </FormGroup>
                        </Form>
                    );
                }
                else{
                    kindEdit = (
                        <div>
                            <button
                                className="btn btn-primary"
                                onClick={() => this.toggleCreateKind(true)}
                                type="button"> Neues Kind anlegen
                            </button>
                            <br/>
                            <br/>
                            <h5>Mehrere Kinder zur Kita hinzufügen</h5>
                            <button
                                className="btn btn-primary" 
                                type="button" 
                                onClick={() => this.downloadMuster()}>
                                Muster
                            </button>
                            <button 
                                className="btn btn-primary" 
                                type="button" 
                                disabled={!this.state.file} 
                                onClick={(event) => this.uploadFileData(event)}>Neue Kinder anlegen</button>
                            <br/>
                            <br/>
                            <br/>
                            <input onChange={(event) => this.onFileChange(event)} type="file"></input>
                        </div>
                    );
                }

            }

        if (this.state.showDeleteKindSuccessAlert) {
            kindEdit = (
                <Alert color="success">
                    <p>Das Kind wurde erfolgreich gelöscht</p>
                </Alert>
            );
        }
        
        if(this.state.showUploadKindSuccessAlert){
            let AnzahlVersuchterHochgeladenerKinder = this.state.createdKinder.length;
            let AnzahlErfolgreichHochgeladenerKinder = this.state.createdKinder.filter(Boolean).length;
            let IndizesUnerfolgreichHochgeladenerKinder = this.state.createdKinder.flatMap((bool, index) => bool ? [] : index + 2);
            let AnzahlUnerfolgreichHochgeladenerKinder = AnzahlVersuchterHochgeladenerKinder - AnzahlErfolgreichHochgeladenerKinder;
            if(AnzahlUnerfolgreichHochgeladenerKinder > 0)
            {
                kindEdit= (
                    <Alert color="success">
                        <p>Es wurde versucht, {AnzahlVersuchterHochgeladenerKinder} Kind(er) hochzuladen:</p>
                        <p>Dabei wurde(n) {AnzahlErfolgreichHochgeladenerKinder} Kind(er) erfolgreich sowie {AnzahlUnerfolgreichHochgeladenerKinder} nicht hochgeladen</p>
                        <br/>
                        <p>Die Datensätze in den Zeilen {this.CreateStringFromIndizes(IndizesUnerfolgreichHochgeladenerKinder)} konnten nicht gelesen werden.</p>
                    </Alert>
                );
            }
            else
            {
                kindEdit= (
                    <Alert color="success">
                        <p>Es wurde versucht, {AnzahlVersuchterHochgeladenerKinder} Kind(er) hochzuladen:</p>
                        <p>Dabei wurde(n) {AnzahlErfolgreichHochgeladenerKinder} Kind(er) erfolgreich hochgeladen!</p>
                    </Alert>
                );
            }
            
        }
        
        return(
            <div>
                <h3>Kinder der Kita {this.state.kita.name}</h3>
                <br />
                {kinderList}
                <br />
                {kindEdit}
            </div>
        );
    };
};

const mapStateToProps = state => {
    return {
        apiUri: state.apiUri,
        token: state.token,
        username: state.username,
    };
};

export default connect(mapStateToProps)(KitaStammdaten);